import React from 'react';
import { View } from 'react-native';
import Text from '../Text';
import { calendarDayColors } from '../Calendar/utils';
import { CalendarEventHelper } from './useCalendarEvents';
import ActivityIndicator from './ActivityIndicator';
import { EventType } from './types';
import { getColorForEventTypes } from './utils';

export type ActivityCalendarDayOwnProps = {
    day: string;
    isTargetMonth: boolean;
    dateTime: string;
    calendarEventsHelper: CalendarEventHelper;
    eventType: EventType;
};

export type ActivityCalendarDayProps = ActivityCalendarDayOwnProps;

const ActivityCalendarDay: React.FC<ActivityCalendarDayProps> = ({
    dateTime,
    day,
    isTargetMonth,
    calendarEventsHelper,
    eventType,
}) => {
    const eventTypes = calendarEventsHelper.getEventTypesForDay(dateTime, eventType);

    return (
        <View
            style={{
                width: '100%',
                height: '100%',
                flexDirection: 'row',
                justifyContent: 'center',
            }}
            testID={`event-type-count-${eventTypes.length}`}
        >
            <View
                style={{
                    height: '100%',
                    flexDirection: 'column',
                    flex: 1,
                    maxWidth: 50,
                    backgroundColor: getColorForEventTypes(eventTypes, !isTargetMonth),
                    borderRadius: 4,
                }}
            >
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    <Text
                        variant="caption-1"
                        color={isTargetMonth ? calendarDayColors.targetMonth : calendarDayColors.nonTargetMonth}
                    >
                        {day}
                    </Text>
                </View>
                <View style={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                    {calendarEventsHelper.getHasEvents(dateTime, eventType) ? (
                        <ActivityIndicator isTargetMonth={isTargetMonth} />
                    ) : null}
                </View>
            </View>
        </View>
    );
};

export default React.memo(ActivityCalendarDay);
